import React from 'react'
import { Button, FormControlLabel, Grid, Switch, TextField, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  UserCompaniesFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import CompanyMenu from './CompanyMenu'
import moment from 'moment'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import DateFilter from './DateFilter'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'

let { User_Config } = Configuration
export default function CompaniesContent ({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userCompaniesLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  let NumbersRegex = /^[0-9]+$/
  let isFilterValid = {
    tax_id: true
  }
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'taxpayer_name',
      label: intl.formatMessage({ id: 'CompanyHeader.TaxpayerName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.TaxpayerName'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'name',
      label: intl.formatMessage({ id: 'CompanyHeader.CompanyName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.CompanyName'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'tax_id',
      label: intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UniqueTaxId'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' })}
              id='tax_id'
              name='tax_id'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.tax_id = !(event.target.value && ((event.target.value.length < 9 || event.target.value.length > 10) || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
              (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.taxOnlyNumbers' })
                : (((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10) && intl.formatMessage({ id: 'validationSchema.taxLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || ((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10)))}
            />
          )
        }
      }
    },
    {
      name: 'subscription_end_date',
      label: intl.formatMessage({ id: 'CompanyHeader.subscriptionEndDate' }),
      options: {
        filter: true,
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return !!data[dataIndex]?.subscription_end_date && <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                                     format="Do MMMM YYYY">{data[dataIndex].subscription_end_date}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='CompanyHeader.subscriptionEndDate'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              column={column}
              id="subscription_end_date"
              label={intl.formatMessage({ id: 'CompanyHeader.subscriptionEndDate' })}
            />
          )
        }
      }
    },
    {
      name: 'uptcp_eligibility_date_from',
      label: intl.formatMessage({ id: 'CompanyHeader.uptcpEligibilityDate' }),
      options: {
        filter: true,
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return !!data[dataIndex]?.uptcp_eligibility_date && <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                                                                      format="Do MMMM YYYY h:mm a">{data[dataIndex].uptcp_eligibility_date}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='CompanyHeader.uptcpEligibilityDate.from'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              column={column}
              id="uptcp_eligibility_date_from"
              label={intl.formatMessage({ id: 'CompanyHeader.uptcpEligibilityDate.from' })}
            />
          )
        }
      }
    },
    {
      name: 'uptcp_eligibility_date_to',
      label: intl.formatMessage({ id: 'CompanyHeader.uptcpEligibilityDate' }),
      options: {
        filter: true,
        filterType: 'custom',
        display: 'false',
        viewColumns: false,
        print: false,
        sort: false,
        download: false,
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='CompanyHeader.uptcpEligibilityDate.to'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              column={column}
              id="uptcp_eligibility_date_to"
              label={intl.formatMessage({ id: 'CompanyHeader.uptcpEligibilityDate.to' })}
            />
          )
        }
      }
    },
    {
      name: 'users_count',
      label: intl.formatMessage({ id: 'CompanyHeader.UsersCount' }),
      options: {
        filter: false
      }
    },
    {
      name: 'active',
      label: intl.formatMessage({ id: 'CompanyHeader.CompanyStatus' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Companies.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Companies.List.Table.Active.Option.NotActive' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.CompanyStatus'/>:
                <span>{!!v ? intl.formatMessage({ id: 'Companies.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Companies.List.Table.Active.Option.NotActive' })}</span>
              </div>
            )
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Companies.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Companies.List.Table.Active.Option.NotActive' })}
              value={value ? true : false}
              control={
                <Switch color="primary" checked={value} value={value ? true : false}/>
              }
              onChange={(event) => {
                updateValue(!JSON.parse(event.target.value))
                activateDeactivateCompany(tableMeta.rowData[0], !JSON.parse(event.target.value), updateValue)
              }}
            />
          )
        }
      }
    },
    {
      name: '',
      options: {
        filter: false,
        print: false,
        viewColumns: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (<CompanyMenu index={dataIndex} data={data} setData={setData} setCount={setCount}/>)
        }
      }
    }
  ]
  const updateLoadedData = (cId, newActiveValue) => {
    let newData = loadedData
    newData.forEach((pageData) => {
      pageData.forEach((company) => {
        if (cId === company.id) {
          company.active = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }

  const activateDeactivateCompany = (cId, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      UserServices.activateDeactivateCompany(cId, { 'active': newActiveValue }, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: newActiveValue ? 'Companies.List.Table.Activate.Success' : 'Companies.List.Table.Deactivate.Success' }),
              color: 'success'
            }, 'success')
            updateLoadedData(cId, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }

      })

    }
  }
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getCompanies({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
            // setUserCompaniesFailure(true)
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = result.data.data
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const downloadAllCompanies = () => {
    UserServices.exportCompanies({
      headers: {
        'Authorization': `Bearer ${keycloak?.token ?? ''}`,
        'Accept': 'application/octet-stream'
      },
      params: filterData(exportFiltersPayload(currentFilter)),
      responseType: 'blob'
    }).then((result) => {
      if (result.data) {
        const type = result.headers['content-type']
        const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = result.headers['content-disposition']
        let fileName = `${intl.formatMessage({ id: 'Sidebar.Links.Companies' })}.xlsx`
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2)
            fileName = fileNameMatch[1]
        }
        link.setAttribute('download', fileName) //or any other extension
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      }
    })
    return false
  }

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (['subscription_end_date', 'uptcp_eligibility_date_from', 'uptcp_eligibility_date_to'].includes(columns[index].name)) {
          filters[columns[index].name] = moment(filterItem[0]).format('DD-MM-YYYY')
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    downloadOptions: { filename: `${intl.formatMessage({ id: 'Sidebar.Links.Companies' })}.csv`, separator: ',' },
    customToolbar: () => {
      return (
        <span className={'custom-toolbar-btn'}>
          <Tooltip title={<FormattedMessage id='PaymentRequests.List.Table.Download'/>}>
            <IconButton onClick={downloadAllCompanies} className={classes.iconButton}>
              <CloudDownloadIcon/>
            </IconButton>
          </Tooltip>
        </span>
      )
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button disabled={!(isFilterValid.tax_id)} color='primary' variant="contained"
                  onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && ['tax_id','subscription_end_date', 'uptcp_eligibility_date_from', 'uptcp_eligibility_date_to'].includes(column))) {
        let newFilters = () => (filterList)
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Companies.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='Companies.Page.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Companies.Table.Title'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
